import React from 'react';

const LoadingSpinner = ({ size = 'default', text = 'Loading...' }) => {
  const sizeClasses = {
    small: 'h-8 w-8',
    default: 'h-16 w-16',
    large: 'h-24 w-24'
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <div className={`${sizeClasses[size]} relative flex items-center justify-center`}>
        {/* Pulsing background effect */}
        <div className="absolute inset-0 bg-primary-100 rounded-full animate-ping opacity-25"></div>
        {/* Branded Logo */}
        <img 
          src="/ynskje logo.svg" 
          alt="Ynskje" 
          className="h-full w-full object-contain relative z-10 animate-pulse"
        />
      </div>
      {text && (
        <p className="mt-6 text-gray-500 font-medium animate-pulse">{text}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;
